



























































import Vue, { PropType } from "vue";
import { Data, Methods, Computed, Props } from "./types";

import SearchTextField from "@/components/Atoms/Forms/SearchTextField/index.vue";
import FloatingMenu from "@/components/Molecules/FloatingMenu/index.vue";
import FloatingMenuButton from "@/components/Atoms/FloatingMenuItems/FloatingMenuButton/index.vue";
import UniversityTag from "@/components/Pages/Rankings/Favorites/Molecules/UniversityTag/index.vue";
import Heading from "@/components/Atoms/Typography/Heading/index.vue";

import { debounce } from "lodash";

export default Vue.extend<Data, Methods, Computed, Props>({
  name: "TagSelectForm",
  components: {
    SearchTextField,
    FloatingMenu,
    FloatingMenuButton,
    UniversityTag,
    Heading
  },
  props: {
    placeholder: {
      type: String as PropType<Props["placeholder"]>,
      default: ""
    },
    recommendTitle: {
      type: String as PropType<Props["recommendTitle"]>,
      default: ""
    },
    selectedTags: {
      type: Array as PropType<Props["selectedTags"]>,
      required: true
    },
    recommendedTags: {
      type: Array as PropType<Props["recommendedTags"]>,
      default: []
    },
    suggestionTags: {
      type: Array as PropType<Props["suggestionTags"]>,
      default: []
    },
    loading: {
      type: Boolean as PropType<Props["loading"]>,
      default: false
    }
  },
  data() {
    return {
      debounceSearch: () => {},
      searchText: ""
    };
  },
  computed: {
    filteredRecommendedTags() {
      return this.recommendedTags.filter(
        recommendedTag =>
          !this.selectedTags.some(tag => tag.id === recommendedTag.id)
      );
    },
    filteredSuggestionTags() {
      return this.suggestionTags.filter(
        suggestionTag =>
          !this.selectedTags.some(tag => tag.id === suggestionTag.id)
      );
    }
  },
  watch: {
    searchText(val: string) {
      if (!val) return;
      this.debounceSearch();
    }
  },
  created() {
    this.initDebounceMethods();
  },

  methods: {
    initDebounceMethods() {
      this.debounceSearch = debounce(() => {
        this.$emit("input", this.searchText);
      }, 500);
    },
    onClickRecommendedTag(tag) {
      this.addTag(tag);
      this.$emit("clickRecommendedTag", tag);
    },
    addTag(tag) {
      const alreadyHaveTag = this.selectedTags.some(e => e.id === tag.id);
      if (alreadyHaveTag) {
        this.resetSuggestionTags();
        return;
      }
      this.searchText = "";
      this.resetSuggestionTags();
      this.$emit("change", [...this.selectedTags, tag]);
    },
    removeTag(tag) {
      const newUniversities = this.selectedTags.filter(e => e.id !== tag.id);
      this.$emit("change", newUniversities);
      this.$emit("remove", tag);
    },
    resetSuggestionTags() {
      this.$emit("input", "");
    }
  }
});
